import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { products } from '../data/mockData';
import { SlidersHorizontal, ChevronDown } from 'lucide-react';

const categories = [
  { value: 'all', label: 'Tous les stores' },
  { value: 'store-banne', label: 'Stores Bannes' },
  { value: 'store-veranda', label: 'Stores Véranda' },
  { value: 'store-projection', label: 'Stores à Projection' },
  { value: 'store-terrasse', label: 'Stores de Terrasse' },
];

const NosStoresPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCat = searchParams.get('cat') || 'all';

  const filtered = selectedCat === 'all'
    ? products
    : products.filter(p => p.category === selectedCat);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Header */}
      <div className="bg-[#1a1a1a] py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-2 text-gray-400 text-sm mb-3">
            <a href="/" className="hover:text-orange-400 transition-colors">Accueil</a>
            <span>/</span>
            <span className="text-white">Nos Stores</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-black text-white mb-2">Nos Stores</h1>
          <p className="text-gray-400 max-w-xl">
            Découvrez notre gamme complète de stores sur mesure, fabriqués en France avec
            des matériaux de qualité professionnelle.
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white border-b border-gray-200 sticky top-[97px] z-30">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-2 py-3 overflow-x-auto">
            <SlidersHorizontal size={16} className="text-gray-400 flex-shrink-0 mr-1" />
            {categories.map((cat) => (
              <button
                key={cat.value}
                onClick={() => {
                  if (cat.value === 'all') {
                    setSearchParams({});
                  } else {
                    setSearchParams({ cat: cat.value });
                  }
                }}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
                  selectedCat === cat.value
                    ? 'bg-orange-500 text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-orange-50 hover:text-orange-600'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <p className="text-gray-400 text-sm mb-6">
          {filtered.length} produit{filtered.length > 1 ? 's' : ''} trouvé{filtered.length > 1 ? 's' : ''}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filtered.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20">
            <p className="text-gray-400 text-lg">Aucun produit dans cette catégorie.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NosStoresPage;
